import React, { useRef, useEffect } from 'react';
import { Rect, Text as KonvaText, Image as KonvaImage, Group, Transformer } from 'react-konva';
import useImage from 'use-image';

export const PlaceholderShape = ({ element, isSelected, onSelect, onChange }) => {
  const groupRef = useRef();
  const trRef = useRef();
  const [previewImg] = useImage(element.previewImage, 'anonymous');

  useEffect(() => {
    if (isSelected && trRef.current && groupRef.current) {
      trRef.current.nodes([groupRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [isSelected]);

  return (
    <>
      <Group
        ref={groupRef}
        x={element.x}
        y={element.y}
        draggable={!element.locked}
        onClick={onSelect}
        onTap={onSelect}
        onDragEnd={(e) => {
          onChange({ ...element, x: e.target.x(), y: e.target.y() });
        }}
        onTransformEnd={(e) => {
          const node = e.target;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();
          node.scaleX(1);
          node.scaleY(1);
          onChange({
            ...element,
            x: node.x(),
            y: node.y(),
            width: Math.max(50, element.width * scaleX),
            height: Math.max(30, element.height * scaleY),
          });
        }}
      >
        {element.previewImage && previewImg ? (
          (() => {
            // Maintain aspect ratio (object-fit: contain)
            const imgW = previewImg.naturalWidth || previewImg.width || element.width;
            const imgH = previewImg.naturalHeight || previewImg.height || element.height;
            const scaleX = element.width / imgW;
            const scaleY = element.height / imgH;
            const scale = Math.min(scaleX, scaleY);
            const drawW = imgW * scale;
            const drawH = imgH * scale;
            const offsetX = (element.width - drawW) / 2;
            const offsetY = (element.height - drawH) / 2;
            return (
              <>
                <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#F5F5F5'} cornerRadius={4} />
                <KonvaImage image={previewImg} x={offsetX} y={offsetY} width={drawW} height={drawH} />
                <Rect width={element.width} height={element.height} fill="transparent" stroke={element.borderColor || '#999999'} strokeWidth={2} dash={[10, 5]} />
                <KonvaText x={5} y={5} text={element.type === 'logoPlaceholder' ? 'LOGO' : element.type === 'qrCodePlaceholder' ? 'QR' : 'PHOTO'} fontSize={12} fill="#FFFFFF" fontFamily="Arial" padding={4} />
              </>
            );
          })()
        ) : (
          <>
            <Rect width={element.width} height={element.height} fill={element.backgroundColor || '#E5E5E5'} stroke={element.borderColor || '#999999'} strokeWidth={2} dash={[10, 5]} cornerRadius={4} />
            <KonvaText
              y={element.height / 2 - 10}
              width={element.width}
              text={element.label || (element.type === 'logoPlaceholder' ? 'LOGO' : element.type === 'qrCodePlaceholder' ? 'QR CODE' : 'PROPERTY PHOTO')}
              fontSize={element.type === 'logoPlaceholder' ? 16 : element.type === 'qrCodePlaceholder' ? 14 : 18}
              fill="#666666"
              fontFamily="Arial"
              align="center"
            />
          </>
        )}
      </Group>
      {isSelected && !element.locked && (
        <Transformer
          ref={trRef}
          flipEnabled={false}
          boundBoxFunc={(oldBox, newBox) => {
            if (Math.abs(newBox.width) < 50 || Math.abs(newBox.height) < 30) return oldBox;
            return newBox;
          }}
        />
      )}
    </>
  );
};
